import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "app/shared/auth/auth.service";

@Component({
  standalone: true,
  selector: "app-auth-callback",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./auth-callback.component.html"
})
export class AuthCallbackComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  errorText = "";

  //ngOnInit() {
  // this.authService
  //   .signinRedirectCallback()
  //   .then((user) => {
  //     if (user === null) {
  //       this.errorText = 'No sign-in request pending.';
  //     } else {
  //       this.router.navigateByUrl(user.state || '/');
  //     }
  //   })
  //   .catch((er) => {
  //     const message: string = er.message;

  //     // Regularly happens when user navigates back into history when the url contains a token that has already been redeemed
  //     if (message.toLowerCase() === 'no matching state found in storage') {
  //       this.router.navigateByUrl('/');
  //     } else {
  //       this.errorText = er.message;
  //     }
  //   });
  // }
}
